import axios from "axios";
import alert from "@/lang/AlertMessages.js";
import label from "@/lang/StaticLabels.js";

export default {
  // MultiMedia Actions .......................................................
  getLastMedia({ dispatch, commit }, data) {
    axios
      .get("Multimedias/LastMultimedias?" + data)
      .then((res) => {
        commit("setLastMedia", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },
  getVideoLastMedia({ dispatch, commit }) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true }
    );
    axios
      .get("Multimedias/LastMultimedias?Type=3&Page=1&Size=1000")
      .then((res) => {
        commit("setVideoLastMedia", res.data.data.items);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },
  getAudioLastMedia({ dispatch, commit }) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true }
    );
    axios
      .get("Multimedias/LastMultimedias?Type=2&Page=1&Size=1000")
      .then((res) => {
        commit("setAudioLastMedia", res.data.data.items);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },
  getPicLastMedia({ dispatch, commit }) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true }
    );
    axios
      .get("Multimedias/LastMultimedias?Type=1&Page=1&Size=1000")
      .then((res) => {
        commit("setPicLastMedia", res.data.data.items);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },
  getChooseMedia({ dispatch, commit }, data) {
    axios
      .get("Multimedias/ChooseMultimedias?" + data)
      .then((res) => {
        commit("setChooseMedia", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getMoreMedia({ dispatch, commit }, data) {
    axios
      .get("Multimedias/MoreLikeMultimedias?" + data)
      .then((res) => {
        commit("setMoreMedia", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },
  getMoreMediaAll({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true }
    );
    axios
      .get("Multimedias/MoreLikeMultimedias?" + data)
      .then((res) => {
        commit("setMoreMedia", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getTabItems({ dispatch, commit }, data) {
    axios
      .get("Multimedias/MultimediasGroups?" + data)
      .then((res) => {
        commit("setTabItems", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getMoreViewMedia({ dispatch, commit }, data) {
    axios
      .get("Multimedias/MoreViewMuiltimedias?" + data)
      .then((res) => {
        commit("setMoreViewMedia", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getSimilarMedia({ dispatch, commit }, data) {
    axios
      .get("Multimedias/GetSimilarMultimedia?" + data)
      .then((res) => {
        commit("setSimilarMedia", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getOneMedia({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true }
    );
    axios
      .get("Multimedias/GetOneMultimedia?id=" + data)
      .then((res) => {
        commit("setOneMedia", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },
  // Comments Actions .................................................................
  // getComments({ dispatch, commit }, data) {
  //   commit(
  //     "setLoading",
  //     { status: 1, message: label.caption.loading },
  //     { root: true }
  //   );
  //   axios
  //     .get("Comments/GetComments?" + data)
  //     .then((res) => {
  //       commit("setComments", res.data.data);
  //     })
  //     .catch((error) => {
  //       dispatch("errorGETHandler", error, { root: true });
  //     })
  //     .finally(() => {
  //       setTimeout(() => {
  //         commit("setLoading", { status: 0, message: "" }, { root: true });
  //       }, 500);
  //     });
  // },
  getComments({ dispatch, commit }, data) {
    commit("setLoading", 1, { root: true });
    axios
      .get("Comments/GetComments?" + data)
      .then((res) => {
        commit("setComments", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        commit("setLoadBtn", false);
        setTimeout(() => {
          commit("setLoading", 0, { root: true });
        }, 800);
      });
  },
  addComment({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post("Comments/AddComment", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.addComment,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 800);
      });
  },
  //likes Actions .......................................................
  addLikeAndDisLike({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post("Multimedias/AddLike?" + data)
      .then((res) => {
        commit("setLiks", res.data.data);
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.submitLike,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 500);
      });
  },
  //Report Actions .......................................................
  addReport({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post("Reports/AddReport", data)
      .then((res) => {
        commit("setReport", res.data.data);
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.addreport,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 500);
      });
  },
  // Banner Actions .................................................................
  getAudioBannerRight({ dispatch, commit }, data) {
    axios
      .get("Banners?" + data)
      .then((res) => {
        commit("setAudioBannerRight", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },
  getAudioBannerLeft({ dispatch, commit }, data) {
    axios
      .get("Banners?" + data)
      .then((res) => {
        commit("setAudioBannerLeft", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },
};
